import { Address, useDaumPostcodePopup } from 'react-daum-postcode';

type TypeKakaoPostcodeSearchProps = {
  onComplete?: (zipCode: string, address: string) => void;
};

/**
 * 카카오 우편번호 API 호출 팝업 커스텀 훅
 */
const useKakaoPostcodeSearch = ({ onComplete }: TypeKakaoPostcodeSearchProps = {}) => {
  const openPostCodePopup = useDaumPostcodePopup();

  const handleZipCodeSearchOpen = () => {
    openPostCodePopup({
      onComplete: handleZipCodeSearchComplete,
      popupTitle: 'FBK - 우편번호 찾기',
      width: 529,
      height: 631,
      left: (window.innerWidth - 529) / 2,
      top: (window.innerHeight - 631) / 2,
    });
  };

  const handleZipCodeSearchComplete = (data: Address) => {
    let fullAddress = data.address;
    let extraAddress = '';

    // 검색된 기본 주소 타입 (R:도로명, J:지번)
    if (data.addressType === 'R') {
      // 법정동/법정리 이름
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      // 건물명
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }

      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    onComplete?.(data.zonecode, fullAddress);
  };

  return { handleZipCodeSearchOpen };
};

export default useKakaoPostcodeSearch;
